import React from "react";
import { css } from "@emotion/react";
import { useStaticQuery, graphql, Link } from "gatsby";
import BackgroundImage from "gatsby-background-image";
import Grid from "./Grid";

const SideProjectGrid = (props) => {
  const data = useStaticQuery(graphql`
    query {
      helveticaBotHero: file(relativePath: { eq: "helvetica-bot-hero.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      todochiHero: file(relativePath: { eq: "todochi.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      nootabHero: file(relativePath: { eq: "nootab-hero.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ninetyNineDaysHero: file(relativePath: { eq: "ninety-nine-days.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  return (
    <Grid>
      <Link
        to="/experiments/helvetica-bot"
        className="item"
        css={css`
          text-decoration: none;
          @media (min-width: 768px) {
            grid-column: span 2;
          }
        `}
      >
        <BackgroundImage
          Tag="div"
          css={css`
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            background-position: top;

            p {
              padding: var(--scale-m3);
              background-color: var(--color-text);
              color: var(--color-bg);
            }

            &:hover {
              p {
                padding: var(--scale-m1);
              }
            }
          `}
          fluid={data.helveticaBotHero.childImageSharp.fluid}
        >
          <p>a Twitter bot that generates t-shirt designs</p>
        </BackgroundImage>
      </Link>
      <Link
        to="/experiments/todochi"
        className="item"
        css={css`
          text-decoration: none;
        `}
      >
        <BackgroundImage
          Tag="div"
          css={css`
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            background-position: top;

            p {
              padding: var(--scale-m3);
              background-color: var(--color-text);
              color: var(--color-bg);
            }

            &:hover {
              p {
                padding: var(--scale-m1);
              }
            }
          `}
          fluid={data.todochiHero.childImageSharp.fluid}
        >
          <p>todochi: a to-do list and virtual pet in one</p>
        </BackgroundImage>
      </Link>
      <Link
        to="/experiments/nootab"
        className="item"
        css={css`
          text-decoration: none;
          @media (min-width: 768px) {
            grid-column: span 2;
          }
        `}
      >
        <BackgroundImage
          Tag="div"
          css={css`
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            background-position: top;

            p {
              padding: var(--scale-m3);
              background-color: var(--color-text);
              color: var(--color-bg);
            }

            &:hover {
              p {
                padding: var(--scale-m1);
              }
            }
          `}
          fluid={data.nootabHero.childImageSharp.fluid}
        >
          <p>nootab: chrome extension for quick notes</p>
        </BackgroundImage>
      </Link>
      <Link
        to="/experiments/ninety-nine-days"
        className="item"
        css={css`
          text-decoration: none;
        `}
      >
        <BackgroundImage
          Tag="div"
          css={css`
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            background-position: top;

            p {
              padding: var(--scale-m3);
              background-color: var(--color-text);
              color: var(--color-bg);
            }

            &:hover {
              p {
                padding: var(--scale-m1);
              }
            }
          `}
          fluid={data.ninetyNineDaysHero.childImageSharp.fluid}
        >
          <p>a photo-first travel and lifestyle blog</p>
        </BackgroundImage>
      </Link>
    </Grid>
  );
};

export default SideProjectGrid;
